import React, { useEffect, useState } from 'react';


// Components
import service from "../common/service"

let sub;

function ShareBlock() {
    const [apiServe, ] = useState(new service());
    const [sharBlocks, setSharBlock] = useState({})

    useEffect(() => {
        getSharBlockInfo();
        sub = apiServe.getevent().subscribe((response) => {
            switch (response.event) {
                case "howToFest|footer|getDetail":
                    if (response.error) {
                    }
                    else {
                        setSharBlock(response.data)
                    }
                    break;
                default:
                    break;
            }
        })
    }, [])

    const getSharBlockInfo = () => {
        apiServe.sendevent("howToFest|footer|getDetail", {})
    }
    // const socialShare = flag => {
    //     if (type === 'facebook') {
    //         window.open("https://www.w3schools.com");
    //     }
    // }
    return (
        <>

            <section className="sd_share_section" >
                <div className="sd_inner_container">
                    <div className="sd_share_sec" >
                        {Object.keys(sharBlocks).length !== 0 && sharBlocks.tile.map((sharBlock, index) => {
                            return (                                

                                sharBlock.type === "outbound"
                                    ? <div className="sd_share_block" key={index}> 
                                        <div className="sd_share_block_inner">
                                            <h2>{sharBlock.title}</h2> 
                                            {/* {HTMLReactParser(sharBlock.description)} */}
                                            <p>{sharBlock.description}</p>
                                            <a href={sharBlock.url} target="_blank" className="sd_ext_link">
                                                {/* {HTMLReactParser(sharBlock.cta)} */}
                                                { sharBlock.cta }
                                                <img src={`${process.env.REACT_APP_IMAGE_PATH}slider_arrow_right_white.svg`} alt="Lorem ipsum cta" title="Lorem ipsum cta" />
                                            </a>
                                        </div>
                                    </div>
                                    : <div className="sd_share_block" key={index}>
                                        <div className="sd_share_block_inner">
                                        <h2>{sharBlock.title}</h2>
                                            {/* {HTMLReactParser(sharBlock.description)} */}
                                            <p>{sharBlock.description}</p>
                                            <ul>
                                                {sharBlock.twitter &&
                                                    <li>
                                                        <a href="https://twitter.com/intent/tweet?url=https://htf.festival.sundance.org" target="_blank">
                                                            <img src={`${process.env.REACT_APP_IMAGE_PATH}twitter_icon.svg`} alt="Twitter" title="Twitter" />
                                                        </a>
                                                    </li>
                                                }
                                                {sharBlock.facebook &&
                                                    <li>
                                                        <a href="https://www.facebook.com/sharer/sharer.php?u=https://htf.festival.sundance.org" target="_blank">
                                                            <img src={`${process.env.REACT_APP_IMAGE_PATH}facebook_icon.svg`} alt="Facebook" title="Facebook" />
                                                        </a>
                                                    </li>
                                                }
                                            </ul>
                                        </div>
                                    </div>
                            )
                        })
                        }
                    </div>
                </div>
            </section>

        </>
    )
}

export default ShareBlock;